import './header';
import './forms';


// AUTOSUGGEST
const autosuggest = document.querySelector('[data-autosuggest]');
const getContainer = e => e.target.closest('.content-search');

if (autosuggest) {
  autosuggest.addEventListener('focus', (e) => {
    const container = getContainer(e);
    container && container.classList.add('suggestions-visible');
  });

  autosuggest.addEventListener('blur', (e) => {
    const container = getContainer(e);
    container && container.classList.remove('suggestions-visible');
  });
}



//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = 0
// module chunks = 0